import {AssignedUser, PartialUser} from "@/shared/timr";

/**
 * Converts a PartialUser (from getAssignableUsers.json) to an AssignedUser
 * for use in assignment panel select tables.
 *
 * Note: Only PartialUser fields are populated — full User fields remain
 * undefined until the assignment is saved and reloaded from the backend.
 * See: TIMR-11984 Fix PartialUser and assignment typing mismatch
 */
export function toAssignableUser(user: PartialUser): AssignedUser {
	return {
		...user,
		elementType: "USER",
		autoAssigned: false,
		hoursPlanned: undefined,
		hoursPlannedManually: undefined,
		recordingLock: undefined,
	} as AssignedUser;
}
